import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const DeliveryTimeChart = ({ data }) => {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">
          Average Delivery Time
        </h5>
      </div>

      <div className="card-body">
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="courier" />

            <YAxis
              label={{
                value: "Days",
                angle: -90,
                position: "insideLeft",
              }}
            />

            <Tooltip
              formatter={(value) =>
                `${value} days`
              }
            />

            <Bar
              dataKey="days"
              fill="#6f42c1"
              radius={[5, 5, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DeliveryTimeChart;